import React, { ReactElement, useEffect } from 'react';
import { useAuth } from 'hooks';
import { Outlet, useNavigate } from 'react-router-dom';
import { RouteList } from 'types';

export const AdminRoot = ({ children }: { children?: ReactElement }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !user.isAdministrator) {
      navigate(RouteList.Home);
    }
  }, [user, navigate]);

  return children ?? <Outlet />;
};
